import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

import { Buttoms, DefaultListOrder } from '../../../private/shared/models/order-list';
import { IProductos } from '../../../private/shared/models/productos';
import { addCartState } from '../../../store/actions';
import { AppState } from '../../../store/app-reducers';
import { CartProductsState } from '../../../store/reducers';
import { SharedAnalyticsService } from '../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../enums/analytics.enum';
import { EventInteraction, GTMInteractions, SECTIONS } from '../../models/Constants';
import { AnalyticsService } from '../../services/analytics.service';
import { OperationsService } from '../../services/operations/operations.service';

@Component({
  selector: 'app-spam-cart',
  templateUrl: './spam-cart.page.html',
  styleUrls: ['./spam-cart.page.scss'],
})
export class SpamCartPage implements OnInit, AfterViewInit, OnDestroy {

  public products: Array<IProductos> = [];
  public referenceProducts: Array<IProductos> = [];
  public productsCart: Array<IProductos> = [];
  public totalPrice = 0;
  public isChange = false;
  public responsable = '';
  public rangeInput: Buttoms = DefaultListOrder.componentContent.range.buttoms;

  private finishSubscriptions: Subject<boolean> = new Subject();
  private startViewSended = false;

  constructor(
    private modalCtrl: ModalController
    , private operationsS: OperationsService
    , private analyticsS: AnalyticsService
    , private sharedAnalyticsS: SharedAnalyticsService
    , private translate: TranslateService
    , private store: Store<AppState>
  ) { }

  ngOnInit() {
    const product$ = this.store.select('products')
      .pipe(
        map(ps => ps.productsList.filter(p => p.modelo === 1)
          .sort((a, b) => (a.prioridad || 0) - (b.prioridad || 0))
          .slice(0, 5)
        )
      );
    const cart$ = this.operationsS.combinerCartOrder$().pipe(tap(this.callbackCartProducts), map<CartProductsState, IProductos[]>(value => value.cartProductos));

    combineLatest([cart$, product$])
      .pipe(
        map(this.callbackCartSpam),
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(this.callbackProducts);

    this.store.select('userData')
      .pipe(map(value => value.Responsable), takeUntil(this.finishSubscriptions))
      .subscribe(this.callbackUserData);
  }

  async ngAfterViewInit() {
    const configurationRange: { initial: number; end: number } = this.translate.instant(`RangeSelector.Store`);
    this.rangeInput = { ...this.rangeInput, ...configurationRange };
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  /**
   * Callback del carrito
   */
  private callbackCartProducts = (resp: CartProductsState) => {
    this.productsCart = resp.cartProductos.concat(resp.cartPromos);
    this.totalPrice = this.productsCart.map(p => (p.precio || 0) * (p.productos || 0)).reduce((a, b) => a + b, 0);
  }

  /**
   * Combinación de productos carrito y spam
   */
  private callbackCartSpam = (combine: [IProductos[], IProductos[]]) => {
    const cart = combine[0];
    const products = combine[1];
    return products.map(p => {
      const index = cart.length > 0 ? cart.findIndex(x => x.clave_producto === p.clave_producto) : -1;
      if (index >= 0) {
        return {
          ...p,
          productos: cart[index].productos
        };
      }
      return p;
    })
  }

  /**
   * Callback de los productos spam
   */
  private callbackProducts = (products: IProductos[]) => {
    this.products = products;
    this.referenceProducts = products;
    if (!this.startViewSended) {
      this.sendEventListView();
    }
  }

  /**
   * Obtiene el nombre del usuario
   */
  private callbackUserData = (responsable: string) => this.responsable = responsable;

  /**
   * Los productos que se estan agregando por card
   */
  public addProducto = (event: { producto: IProductos, productsSelect: number }) => {
    this.isChange = true;
    this.referenceProducts = this.referenceProducts.map(p => {
      if (p.clave_producto === event.producto.clave_producto) {
        return {
          ...p,
          productos: event.productsSelect
        }
      }
      return p;
    });

    const indexCart = this.productsCart.length > 0 ? this.productsCart.findIndex(x => x.clave_producto === event.producto.clave_producto) : -1;
    if (indexCart >= 0) {
      this.productsCart = this.productsCart.length < 1 ? this.referenceProducts.filter(p => (p.productos || 0) > 0) : this.productsCart.map(pc => {
        const index = this.referenceProducts.findIndex(x => x.clave_producto === pc.clave_producto);
        if (index >= 0) {
          return {
            ...pc,
            productos: this.referenceProducts[index].productos
          };
        }
        return pc;
      });
    } else {
      this.productsCart = this.productsCart.concat([{
        ...event.producto,
        productos: event.productsSelect
      }])
    }
    this.totalPrice = this.productsCart.filter(p => (p.productos || 0) > 0).map(p => (p.precio || 0) * (p.productos || 0)).reduce((a, b) => a + b, 0);
  }

  /**
   * Confirma la orden
   */
  public onButton = async () => {
    if (!this.isChange) {
      this.sendEventNotNow();
    }

    const totalProducts = this.productsCart.filter(p => !p.hasOwnProperty('ClavePromo'));
    const zerProducts = totalProducts.filter(p => (p.productos || 0) < 1);
    totalProducts.filter(p => (p.productos || 0) > 0).concat(zerProducts).forEach(producto => {
      this.store.dispatch(addCartState({ cartProducto: producto, productsSelect: producto.productos || 0 }))
    })
    await this.modalCtrl.dismiss(true);
  }

  private sendEventListView = () => {
    this.startViewSended = true;
    this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews.interestProductsView, SECTIONS.TIENDA);
  }

  private sendEventNotNow = () => this.analyticsS.sendEventAnalytics(GTMInteractions.notNowButtonEvent, EventInteraction);

}
